<div class="modal-header">
    <h4 class="modal-title">Pedido {{order.code}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-4">
            <div class="form-group">
                <label>Fecha</label>
                <p>{{order.created_at | date: 'dd/MM/YYYY HH:mm'}}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4">
            <div class="form-group">
                <label>Usuario Registrado</label>
                <p>{{order.user.name}}</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label>Fecha de registro</label>
                <p>{{order.user.created_at | date: 'dd/MM/YYYY HH:mm'}}</p>
            </div>
        </div>
        <div class="col-md-12">
            <hr>
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <h5>Dirección de envío</h5>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Dirección</label>
                        <p>{{order.user_location_address}}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Distrito</label>
                        <p>{{order.user_location_district_name}}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Referencia</label>
                        <p>{{order.user_location_reference}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <hr>
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <h5>¿Quién recibirá el pedido?</h5>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Nombre</label>
                        <p>{{order.user_location_name}}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Apellido</label>
                        <p>{{order.user_location_last_name}}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>DNI</label>
                        <p>{{order.user_location_dni}}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Teléfono</label>
                        <p>{{order.user_location_phone}}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Correo</label>
                        <p>{{order.user_location_email}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <hr>
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Estado</label>
                        <p>{{order.status_nice}}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Método de pago</label>
                        <p>{{order.payment_method_nice}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="order.payment_method == 1" class="row">
        <div class="col-md-12">
            <hr>
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Marca</label>
                        <p>{{order.card_brand}}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Tarjeta</label>
                        <p>{{order.card_masked}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <hr>
        </div>
        <div class="col-md-12">
            <div class="table-responsive">
                <table class="table m-table m-table--head-bg-success table-bordered">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Nombre</th>
                        <th>Foto</th>
                        <th>Cantidad</th>
                        <th>Precio</th>
                        <th>Importe</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of items; let i = index">
                        <td>{{i + 1}}</td>
                        <td>
                            {{item.product_name}} <br>
                            <ng-container *ngFor="let combination of item.combinations_descriptions">
                                {{combination.name}}: {{combination.description}}
                            </ng-container>
                        </td>
                        <td>
                            <img [src]="item.photo_url" [alt]="item.product_name" class="img-prod">
                        </td>
                        <td>{{item.quantity}}</td>
                        <td>{{item.price | currency: 'S/ '}}</td>
                        <td>{{(item.price * item.quantity) | currency: 'S/ '}}</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <th colspan="5" class="text-right">TOTAL</th>
                        <td>{{order.total | currency: 'S/ '}}</td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer" *ngIf="order.status == 1 || order.status == 5">
    <div class="col-md-12">
        <div class="text-right">
            <button class="btn btn-primary" [ngClass]="{'m-loader m-loader--light m-loader--right': loading}"
                    [disabled]="loading" (click)="delivered()">Marcar como entregado
            </button>
        </div>
    </div>
</div>
